import React, { useEffect, useRef, useState } from "react";
import tw from "twin.macro";
import { createAddress, updateAddress } from "api/AddressApi";
import toast from "react-hot-toast";
import { getCustomerId } from "utility/HeaderConfig";
import { useNavigate, useLocation, Link } from "react-router-dom";
import OfferTag from "./OfferTag";                               //eslint-disable-line
const StyledDiv = tw.div`font-display overflow-hidden`;          //eslint-disable-line
const BgColor = tw.div`bg-zinc-100 py-4 sm:py-10`;               // eslint-disable-line

const inputs = {
  display: "block",
  width: "100%",
  padding: "12px 14px 12px 20px",
  fontFamily: "inherit",
  fontSize: 12,
  color: "#441574d8",
  background: "#f6effdd8",
  border: "1px solid #f6effdd8",
  borderRadius: 10,
  outline: "none",
  transition: "border-color .14s, box-shadow .14s",
};

const getInitialState = () => {
  const initialState = {
    customerId: getCustomerId(),
    customerName: "",
    mobileNo: "",
    pincodeNumber: "",
    stateName: "",
    address2: "",
    address1: "",
    latitude: "",
    longitude: "",
    landmark: "",
    districtName: "",
    addressId: "",
    isButtonPressed: false,
  };
  return initialState;
};

export default function AddAddress(props) {
  const history = useNavigate();
  const location = useLocation();
  const parm = location.state;
  const viewAddressElemnt = useRef();
  const [state, setState] = useState(getInitialState());
  const [MobileError, setMobileError] = useState(false);
  const [errorUser, setErrorUser] = useState(false);

  const updateFieldState = (fieldName, fieldValue) => {
    setState((prev) => ({ ...prev, [fieldName]: fieldValue }));
  };

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      ...parm,
    }));
    //eslint-disable-next-line
  }, [parm]);

  const validateField = () => {
    const mobileReg = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    if (!mobileReg.test(state.mobileNo) && state.mobileNo !== "") {
      setMobileError(true);
    } else {
      setMobileError(false);
    }
    if (
      mobileReg.test(state.mobileNo) &&
      state.address1 &&
      state.pincodeNumber
    ) {
      return true;
    } else {
      setErrorUser(true);
    }
  };

  const postAjaxRequest = () => {
    if (validateField()) {
      const {
        customerId,
        customerName,
        mobileNo,
        pincodeNumber,
        stateName,
        address2,
        address1,
        // latitude,
        // longitude,
        landmark,
        districtName,
      } = state;
      setState((prev) => ({ ...prev, isButtonPressed: true }));
      const createAddressData = JSON.stringify({
        customerId: customerId,
        customerName: customerName,
        mobileNo: mobileNo,
        pincodeNumber: pincodeNumber,
        stateName: stateName,
        address2: address2,
        address1: address1,
        // latitude : latitude,
        // longitude :longitude,
        landmark: landmark,
        districtName: districtName,
      });
      const respData = createAddress(createAddressData);
      respData
        .then(
          //eslint-disable-next-line
          (data) => {
            toast.success("Address Created Successfully..!", {
              position: "top-right",
            });
            setTimeout(() => {
              history("/CheckoutPage");
            }, 1000);
            setState(getInitialState());
            if (viewAddressElemnt && viewAddressElemnt.current)
              return viewAddressElemnt.current.click();
          },
        )
        .catch((err) => {
          // toast.error(err.response.data.displayMessage, {
          //   position: "top-right",
          // });
          setState((prev) => ({ ...prev, isButtonPressed: false }));
        });
    }
  };

  const updateAjaxRequest = () => {
    if (validateField()) {
      const {
        addressId,
        customerName,
        mobileNo,
        pincodeNumber,
        stateName,
        address2,
        address1,
        latitude,
        longitude,
        landmark,
        districtName,
      } = state;
      setState((prev) => ({ ...prev, isButtonPressed: true }));
      const createAddressData = JSON.stringify({
        id: addressId ? addressId : parm.id,
        customerName,
        mobileNo,
        pincodeNumber,
        stateName,
        address2,
        address1,
        latitude,
        longitude,
        landmark,
        districtName,
      });
      const respData = updateAddress(createAddressData);
      respData
        .then(
          //eslint-disable-next-line
          (data) => {
            toast.success("Address Updated Successfully..!", {
              position: "top-right",
            });
            setTimeout(() => {
              history("/CheckoutPage");
            }, 1000);
            setState(getInitialState());
            if (viewAddressElemnt && viewAddressElemnt.current)
              return viewAddressElemnt.current.click();
          },
        )
        .catch((err) => {
          // toast.error(err.response.data.displayMessage, {
          //   position: "top-right",
          // });
          setState((prev) => ({ ...prev, isButtonPressed: false }));
        });
    }
  };

  return (
    <div>
      <div
        className="ptSans px-sm-5 px-0 d-flex justify-content-between align-items-center"
        style={{ background: "var(--surface-cream)", height: "70px" }}
      >
        <div>
          <div
            style={{
              color: "var(--ink-700)",
              fontWeight: 500,
              textTransform: "capitalize",
            }}
          >
            ADDRESS DETAILS
          </div>
          <Link
            to="/CheckoutPage"
            style={{
              color: "var(--ink-700)",
              textDecoration: "none",
              fontWeight: 400,
              fontSize: "10px",
            }}
          >
            CHECKOUT PAGE
          </Link>
          {" > "}
          <span
            style={{
              color: "var(--ink-700)",
              fontWeight: 400,
              fontSize: "10px",
            }}
          >
            ADDRESS
          </span>
        </div>
        <Link
          to="/CheckoutPage"
          style={{
            textDecoration: "none",
            fontSize: "11px",
            border: "1px solid #cf84fa",
            padding: "6px 12px",
            borderRadius: "4px",
            color: "#cf84fa",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path
              d="M20.6621 17C18.933 19.989 15.7013 22 11.9999 22C6.47703 22 1.99988 17.5228 1.99988 12C1.99988 6.47715 6.47703 2 11.9999 2C15.7013 2 18.933 4.01099 20.6621 7M11.9999 8L7.99995 12M7.99995 12L11.9999 16M7.99995 12H21.9999"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg> BACK TO SHIPPING
        </Link>
      </div>
      <div className="container">
        <div className="row my-sm-5 my-3">
          <div className="col-md-7">
            {/* <div className="bg-gray-300">
                  <div className="py-12">
                    <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg md:max-w-xl mx-2"> */}
            <div
              className="px-5"
              // tw="py-2 border-b-4 border-custom-100"
            >
              <b>Address</b>
            </div>
            <div className="px-sm-5 py-2 px-2 py-sm-4">
              <form className="needs-validation">
                <div className="row mb-3">
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                Name
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-10">
                    <input
                      type="text"
                      className={`ej-input-field w-100 py-2  ${state.customerName === "" && errorUser ? "border-danger" : ""}`}
                      id="customerName"
                      style={{ ...inputs }}
                      value={state.customerName}
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1 text-sm "
                      placeholder="Enter Your Name"
                      onChange={(e) =>
                        updateFieldState("customerName", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                Mobile Number
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-10">
                    <input
                      type="text"
                      style={{ ...inputs }}
                      className={`ej-input-field w-100 py-2  ${(state.mobileNo === "" && errorUser) || MobileError ? "border-danger" : ""} `}
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1
                      //     text-sm"
                      id="mobileNo"
                      value={state.mobileNo}
                      placeholder="Enter Mobile Number "
                      onChange={(e) =>
                        updateFieldState("mobileNo", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                Address
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-10">
                    <textarea
                      className={`ej-input-field w-100 py-2  ${state.address1 === "" && errorUser ? "border-danger" : ""}`}
                      id="address2"
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1
                      // text-sm"
                      placeholder="Enter Address "
                      style={{ ...inputs }}
                      rows={2}
                      value={state.address1}
                      onChange={(e) =>
                        updateFieldState("address1", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                Landmark
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-5">
                    <input
                      type="text"
                      style={{ ...inputs }}
                      className={`ej-input-field w-100 py-2  ${state.landmark === "" && errorUser ? "border-danger" : ""}`}
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1
                      //     text-sm"
                      id="landmark"
                      placeholder="Enter Landmark "
                      value={state.landmark}
                      onChange={(e) =>
                        updateFieldState("landmark", e.target.value)
                      }
                    />
                  </div>
                  {/* </div>
                          <div className="row mb-3"> */}
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                Zip / Postal Code{" "}
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-5">
                    <input
                      type="text"
                      style={{ ...inputs }}
                      className={`ej-input-field w-100 py-2  ${state.pincodeNumber === "" && errorUser ? "border-danger" : ""}`}
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1
                      //     text-sm"
                      id="pincodeNumber"
                      placeholder="Enter Postal Code"
                      value={state.pincodeNumber}
                      onChange={(e) =>
                        updateFieldState("pincodeNumber", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                District
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-5">
                    <input
                      type="text"
                      className={`ej-input-field w-100 py-2  ${state.districtName === "" && errorUser ? "border-danger" : ""}`}
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1
                      //     text-sm"
                      id="districtName"
                      style={{ ...inputs }}
                      placeholder="Enter District "
                      value={state.districtName}
                      onChange={(e) =>
                        updateFieldState("districtName", e.target.value)
                      }
                    />
                  </div>
                  {/* </div>
                          <div className="mb-3"> */}
                  {/* <div className="col-md-3 d-flex justify-content-between align-items-center">
                              <label
                                for="inputPassword6"
                                className="col-form-label"
                              >
                                State
                              </label>
                              <small className="text-right d-sm-block d-none">
                                :
                              </small>
                            </div> */}
                  <div className="col-md-5">
                    <input
                      type="text"
                      className={`ej-input-field w-100 py-2  ${state.stateName === "" && errorUser ? "border-danger" : ""}`}
                      // tw="focus:outline-none focus:border-custom-100
                      // focus:ring-1
                      //     text-sm"
                      id="stateName"
                      style={{ ...inputs }}
                      placeholder="Enter State"
                      value={state.stateName}
                      onChange={(e) =>
                        updateFieldState("stateName", e.target.value)
                      }
                    />
                  </div>
                </div>
                {/* <hr className="mb-3" /> */}
                <div className="ej-save-btn">
                  {state?.addressId || parm?.id ? (
                    <button
                      className="ej-btn"
                      onClick={updateAjaxRequest}
                      style={{
                        background:
                          "linear-gradient(135deg, #d06cf8ec 0%, #8075f7f3 100%)",
                        color: "white",
                      }}
                      type="button"
                      disabled={state.isButtonPressed}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      className="ej-btn"
                      onClick={postAjaxRequest}
                      style={{
                        background:
                          "linear-gradient(135deg, #d06cf8ec 0%, #8075f7f3 100%)",
                        color: "white",
                      }}
                      type="button"
                      disabled={state.isButtonPressed}
                    >
                      Save
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
          {/* </div>
                </div>
              </div> */}
        </div>
      </div>
    </div>
  );
}
